import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import iconClose from 'assets/images/eventBoatRacing/iconClose.png'
import imgTitle from 'assets/images/eventBoatRacing/imgEventCongrats.png'
import imgTitleItem from 'assets/images/eventBoatRacing/imgEventCongratsItem.png'
import imgPrizePhone from 'assets/images/eventBoatRacing/imgPrize1.png'
import imgPrizeMoney1 from 'assets/images/eventBoatRacing/imgPrize2.png'
import imgPrizeMoney2 from 'assets/images/eventBoatRacing/imgPrize3.png'
import imgPhone from 'assets/images/eventBoatRacing/imgPhone.png'
import imgKip1 from 'assets/images/eventBoatRacing/imgKip1.png'
import imgKip2 from 'assets/images/eventBoatRacing/imgKip2.png'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'
import {
	getCheckEventBoatRacingQuery,
	getRankEventBoatRacingQuery,
} from 'dataLayer/game'
import { getUserQuery } from 'dataLayer/user'
import { getData, setData } from 'utils/localStorage'
import { useNavigate } from 'react-router-dom'
import { PATHS } from 'config/routes'

function WinnerBoatRacing(prop) {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [winnerPopup, setWinnerPopup] = useState(0)
	const [openModal, setOpenModal] = useState(false)
	const handleCancel = () => {
		setOpenModal(false)
	}

	const { data: eventBoatRacing, isLoading: isLoadingEvent } = useQuery(
		getCheckEventBoatRacingQuery(),
	)
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const { data: rankBoatRacing } = useQuery(getRankEventBoatRacingQuery())

	useEffect(() => {
		if (eventBoatRacing?.is_show && eventBoatRacing?.is_finished) {
			if (user) {
				if (rankBoatRacing && rankBoatRacing?.ranks) {
					const listTopUser = [
						rankBoatRacing?.ranks?.data[0]?.userId,
						rankBoatRacing?.ranks?.data[1]?.userId,
						rankBoatRacing?.ranks?.data[2]?.userId,
					]

					const indexTopUser = listTopUser.indexOf(user?.id)

					if (indexTopUser !== -1) {
						const checkWatched = getData(
							`watched_pop_up_${indexTopUser + 1}_${user?.id}`,
						)
						if (!checkWatched) {
							setOpenModal(true)
							setWinnerPopup(indexTopUser)
							setData(`watched_pop_up_${indexTopUser + 1}_${user?.id}`, true)
						}
					} else {
						const checkWatched = getData('watched_pop_up_4')
						if (!checkWatched) {
							setOpenModal(true)
							setWinnerPopup(3)
							setData('watched_pop_up_4', true)
						}
					}
				}
			} else {
				const checkWatched = getData('watched_pop_up_4')
				if (!checkWatched) {
					setOpenModal(true)
					setWinnerPopup(3)
					setData('watched_pop_up_4', true)
				}
			}
		}
	}, [rankBoatRacing, eventBoatRacing, user])

	const handleNavigate = () => {
		navigate(PATHS.RESULT_EVENT_BOAT_RACING_PAGE)
		handleCancel()
	}

	const listItem = [
		{
			imgGift: imgPrizePhone,
			description: t('event.boat_racing.result.top_1'),
		},
		{
			imgGift: imgPrizeMoney1,
			description: t('event.boat_racing.result.top_2'),
		},
		{
			imgGift: imgPrizeMoney2,
			description: t('event.boat_racing.result.top_3'),
		},
	]

	const innerHeight = window.innerHeight
	return (
		<Modal
			centered
			show={openModal}
			// show={true}
			onHide={handleCancel}
			className={`modal-winner-event winner-boat-racing ${winnerPopup === 3 ? 'modal-all' : ''
				}`}
			width="453px"
			style={{ height: `${innerHeight}px` }}
		>
			<span onClick={handleCancel} className="btn-close">
				<img src={iconClose} alt="close" />
			</span>
			<div className="winning">
				<span className="winning-title">
					{winnerPopup === 3 ? (
						<img src={imgTitle} alt="title" />
					) : (
						<img src={imgTitleItem} alt="title" />
					)}
				</span>
				{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
					<span className="winning-gift">
						<img src={listItem[winnerPopup].imgGift} alt="gift" />
					</span>
				)}
				<div className="winning-foot">
					{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
						<div className="winning-foot-text">
							{listItem[winnerPopup].description}
						</div>
					)}
					{winnerPopup === 3 && (
						<div className="winning-foot-gift">
							<div className="winning-foot-gift-box">
								<div className="winning-foot-gift-box-item">
									<div className="item-rank">1st prize</div>
									<img
										src={imgPhone}
										alt="icon gift"
										className="img-gift-phone"
									/>
									<div className="item-info">
										<span>{rankBoatRacing?.ranks?.data[0]?.full_name}</span>
										<span>{rankBoatRacing?.ranks?.data[0]?.msisdn}</span>
									</div>
								</div>

								<div className="winning-foot-gift-box-item">
									<div className="item-rank">2nd prize</div>
									<img src={imgKip1} alt="icon gift" />
									<div className="item-info">
										<span>{rankBoatRacing?.ranks?.data[1]?.full_name}</span>
										<span>{rankBoatRacing?.ranks?.data[1]?.msisdn}</span>
									</div>
								</div>

								<div className="winning-foot-gift-box-item">
									<div className="item-rank">3rd prize</div>
									<img src={imgKip2} alt="icon gift" />
									<div className="item-info">
										<span>{rankBoatRacing?.ranks?.data[2]?.full_name}</span>
										<span>{rankBoatRacing?.ranks?.data[2]?.msisdn}</span>
									</div>
								</div>
							</div>
							<div className="winning-foot-gift-text">
								{t('event.boat_racing.result.all')}
							</div>
						</div>
					)}

					<Button
						key="submit"
						type="primary"
						className="text-uppercase"
						onClick={handleNavigate}
					>
						{t('event.boat_racing.result.see_details')}
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default WinnerBoatRacing
